<template>
    <a-modal class="permissions" :visible="permissionVisible" centered maskClosable width="620px" @cancel="$emit('close')">
        <template #title>
            <h3>温馨提示</h3>
        </template>
        <template #closeIcon>
            <img src="@/assets/workbench/close.svg" alt="" />
        </template>
        <template v-if="!applicationFlag">
            <img src="@/assets/workbench/permission/p1.png" alt="" />
            <p>非常抱歉，普通用户暂时无权使用该功能，请联系管理员申请试用权限后再试。</p>
        </template>
        <template v-else>
            <img src="@/assets/workbench/permission/p2.png" alt="">
            <p>您好，您的试用申请已提交，请耐心等待管理员核实。</p>
        </template>
        <template #footer v-if="!applicationFlag">
            <a-button class="tryout">申请试用</a-button>
            <a-button class="demo-pro">创建Demo项目</a-button>
            <a-button class="permission-list">查看权限列表</a-button>
        </template>
        <template v-else #footer></template>
    </a-modal>
</template>
<script>
    export default {
        data() {
            return {
                applicationFlag: false, // false 没有申请试用 true 提交申请试用成功

            }
        },
        props: {
            permissionVisible: {
                type: Boolean
            }
        }
    }
</script>
<style lang="less">
@import './index.less';
</style>
